import { NgModule } from '@angular/core';
import { LogoComponent } from './logo/logo.component';
import { CardSpinnerComponent } from './card-spinner/card-spinner/card-spinner.component';
import { MzSpinnerModule } from 'ng2-materialize';
import { RouterModule } from '@angular/router';
import { TopNavigationComponent } from './top-navigation/top-navigation.component';
import { FooterComponent } from './footer/footer/footer.component';


const sharedComponents = [
  LogoComponent,
  CardSpinnerComponent,
  TopNavigationComponent,
  FooterComponent
];

@NgModule({
  imports:      [ MzSpinnerModule,
                  RouterModule ],
  exports:      sharedComponents,
  declarations: sharedComponents
})
export class SharedElementsModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/sharedElements.module.ts